<template>
    <div class="px-3 py-2">
        <v-form
            ref="forcar"
            lazy-validation
        >
            <b-sidebar id="add_crmnote" aria-labelledby="sidebar-no-header-title" no-header backdrop width="700px" style="direction:ltr" right title="إضافة ملاحظة" shadow >
    <template #default="{ hide }">
      <div class="m-1 text-start" style="direction:rtl">
        <div style="width:120px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
          <span>إضافة ملاحظة</span>
        </div>
        <div @click="hide" id="hideNotes" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
          <span>اغلاق</span>
      </div>
    </div>
                <v-divider></v-divider>
                <v-row style="direction:rtl" class="m-2">
                    <v-col cols="12" md="12" sm="12">
                         <label>اختر الحالة</label>
                        <b-input-group>
                        <b-form-select class="selborder"
                            v-model="status"
                            :options="statuses"
                        ></b-form-select>
                                <b-input-group-addon style="margin-right:-20px;margin-top:5px">
                                    <i class="fas fa-arrow-down"></i>
                                </b-input-group-addon>
                            </b-input-group>
                    </v-col>
                    <v-col cols="12" md="12" sm="12">
                        <label>نص الملاحظة</label>
                        <b-form-textarea class="inborder"
                            v-model="message"
                            ></b-form-textarea>
                    </v-col>
                    <v-col cols="12" md="12" sm="12">
                        <label>الملاحظات السابقة</label>
                        <div class="card">
                            <div class="card-body" style="padding:0px;">
                                <table class="table table-bordered table-striped table-hover">
                                    <thead class="thead-light">
                                        <tr>
                                            <th class="text-center backBlack">التاريخ</th>
                                            <th class="text-center backBlack">التوقيت</th>
                                            <th class="text-center backBlack">اضيفت بواسطة</th>
                                        </tr>
                                    </thead>
                                    <tbody v-for="(note, index) in notes" :key="index">
                                        <tr>
                                            <td>{{ note.date }}</td>
                                            <td>{{ note.time }}</td>
                                            <td>{{ note.created_by }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-start" v-html="note.note.replace('\n','<br>')"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </v-col>
                </v-row>
    </template>
                <template #footer="" class="shadow">
                    <div class="d-flex text-light align-items-center px-3 py-2">
                    <b-button type="button" @click="addNote()" variant="success" class="ma-2" style="width:100px;">إضافة</b-button>
                    </div>
                </template>
            </b-sidebar>
        </v-form>
    </div>
</template>

<script>
import axios from 'axios'
import {SnotifyPosition} from 'vue-snotify'
export default{
    data() {
        return {
            status: 1,
            message: '',
            orderid: 0,
            notes: [],
            crmid: 0,
            statics: {
                crmStatus: []
            },
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        statuses: function() {
            let t=[]
            for(let i=0;i<this.statics.deals_status.length;i++){
                t.push({text:this.statics.deals_status[i][`name_${this.lang.langname}`],value:this.statics.deals_status[i].id})
            }
            return t;
        }
    },
    methods: {
        getNotes(){
            const post = new FormData();
            post.append("type" , "getDealCRMNotes");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[crmid]",this.crmid);
            axios.post(
                this.$store.state.SAMCOTEC.r_path , post
            )
            .then((response) => {
                const res = response.data;
                this.notes = res.results.data;
            });
        },
        addNote(){
            if(this.message == ''){
                return false;
            }
            const post = new FormData();
            post.append("type" , "addDealNoteToCRM");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[crmid]",this.crmid);
            post.append("data[message]",this.message);
            post.append("data[status]",this.status);
            post.append("data[type]",1);
            axios.post(
                this.$store.state.SAMCOTEC.r_path , post
            )
            .then((response) => {
                const res = response.data;
                let message = this.lang.addes_successfuly;
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.getNotes();
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                this.message = '';

            });


        }
    },
    created() {
        //this.getNotes();
    },
}
</script>